import { listCapwayJobStatuses, runCapwayJob, updateCapwaySchedule } from '@/api/invoices'
import { CAPWAY_JOB_DESCRIPTIONS, CAPWAY_JOB_LABELS } from '@/lib/capwayJobs'
import { JobsSection } from './JobsSection'

export function CapwayJobsSection(): React.ReactElement {
  return (
    <JobsSection
      title="Capway"
      description="Fakturering och inbetalningar."
      labels={CAPWAY_JOB_LABELS}
      descriptions={CAPWAY_JOB_DESCRIPTIONS}
      loadStatuses={listCapwayJobStatuses}
      runJob={runCapwayJob}
      updateSchedule={updateCapwaySchedule}
    />
  )
}
